// profile/mutations.ts
import Vue from 'vue';
import { MutationTree } from 'vuex';
import {RootState} from './types';
import {User} from 'firebase';

export const mutations: MutationTree<RootState> = {
    setCurrentUser(state, payload: User | undefined) {
        if (state) {
            state.currentUser = payload ? payload : undefined;
            state.signedIn = !!payload;
        }
    },
};
